import React, { useState } from 'react';
import { Modal, ModalBody, ModalFooter, Button, Label, FormGroup, Col, Row } from 'reactstrap';
import DatePickerOnly from 'src/shared/components/form/DatePickerOnly';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { showNotification, successNofication } from 'src/shared/components/Notification';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';
import PropTypes from 'prop-types';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const DutyRoasterUploadModal = ({ isOpen, toggle, refreshData }) => {
    const [effectiveDateFrom, setEffectiveDateFrom] = useState(null);
    const [effectiveDateTo, setEffectiveDateTo] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploading, setUploading] = useState(false);

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const handleUpload = async () => {
        if (!effectiveDateFrom) {
            showNotification("theme-light", "ltr", "Warning", "Please select an effective from date.");
            return;
        }
        if (!effectiveDateTo) {
            showNotification("theme-light", "ltr", "Warning", "Please select an effective to date.");
            return;
        }
        if (!selectedFile) {
            showNotification("theme-light", "ltr", "Warning", "Please select a file to upload.");
            return;
        }

        const formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('effectiveFrom', effectiveDateFrom);
        formData.append('effectiveTo', effectiveDateTo);

        try {
            setUploading(true);
            const response = await PndRestApi.UploadRiderRoasterData(formData);
            if (response.status === 200 && response.data.status === 200) {
                successNofication("theme-light", "ltr", "Success", "File uploaded successfully!");
                if (refreshData) refreshData();
                toggle();
                // Reset state
                setEffectiveDateFrom(null);
                setEffectiveDateTo(null);
                setSelectedFile(null);
            } else {
                showNotification("theme-light", "ltr", `Error Code: ${response.data.status}`, response.data.message);
            }
        } catch (error) {
            console.error('Error uploading file:', error);
            showNotification("theme-light", "ltr", "Error", ERROR_MESSAGES.tryCatchError);
        } finally {
            setUploading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} className="theme-light modal-dialog-centered">
            <div className="modal__header" style={{ borderBottom: '1px solid #eee', paddingBottom: '10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <CloudUploadIcon style={{ color: '#3f51b5', fontSize: '28px' }} />
                    <h4 className="bold-text label-text modal__title text-uppercase" style={{ margin: 0 }}>Upload Rider Duty Roster</h4>
                </div>
                <button
                    className="lnr lnr-cross modal__close-btn"
                    type="button"
                    onClick={toggle}
                    style={{ position: 'static', marginLeft: 'auto' }}
                />
            </div>
            <ModalBody style={{ padding: '30px 20px' }}>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Label for="effective-date-from" style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>
                                Effective Date From <span className="text-danger">*</span>
                            </Label>
                            <DatePickerOnly value={effectiveDateFrom} setDate={setEffectiveDateFrom} name="effectiveDateFrom" />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Label for="effective-date-to" style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>
                                Effective Date To <span className="text-danger">*</span>
                            </Label>
                            <DatePickerOnly value={effectiveDateTo} setDate={setEffectiveDateTo} name="effectiveDateTo" />
                        </FormGroup>
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col md={12}>
                        <FormGroup>
                            <Label for="file-upload" style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>
                                Select Excel File (.xlsx, .xls) <span className="text-danger">*</span>
                            </Label>
                            <div style={{
                                border: '2px dashed #dee2e6',
                                borderRadius: '8px',
                                padding: '20px',
                                textAlign: 'center',
                                backgroundColor: '#f8f9fa',
                                cursor: 'pointer'
                            }}
                                onClick={() => document.getElementById('file-upload').click()}
                            >
                                <input
                                    type="file"
                                    id="file-upload"
                                    accept=".xlsx, .xls"
                                    onChange={handleFileChange}
                                    style={{ display: 'none' }}
                                />
                                <CloudUploadIcon style={{ fontSize: '48px', color: '#adb5bd', marginBottom: '10px' }} />
                                <p style={{ margin: 0, color: '#6c757d' }}>
                                    {selectedFile ? selectedFile.name : 'Click here to browse or drag and drop your file'}
                                </p>
                            </div>
                        </FormGroup>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter style={{ borderTop: '1px solid #eee', paddingTop: '15px' }}>
                <Button color="secondary" onClick={toggle} style={{ borderRadius: '20px', padding: '8px 25px' }}>Cancel</Button>
                <Button
                    color="primary"
                    onClick={handleUpload}
                    disabled={uploading}
                    style={{ borderRadius: '20px', padding: '8px 25px', backgroundColor: '#3f51b5', border: 'none' }}
                >
                    {uploading ? 'Uploading...' : 'Upload Now'}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

DutyRoasterUploadModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    refreshData: PropTypes.func,
};

export default DutyRoasterUploadModal;
